export function arrayBufferToBase64(buffer: ArrayBuffer): string {
	let result = ""
	const bytes = new Uint8Array(buffer)
	const length = bytes.byteLength
	for (let i = 0; i < length; i++) {
		result += String.fromCharCode(bytes[i])
	}
	return btoa(result)
}
